<template>
  <div>
    <GoBackView />
    <MineHeaderView @click-icon="openMenu" />
    <MineMenuView ref="mmv" />
    <EditInfoView ref="editInfo" />
    <EditCardView />
    <EditPayPasswordView v-if="usrData" :usrInfo="usrData" @refresh-usrinfo="getUsr" />
  </div>
</template>

<script>
import {
  MineHeaderView,
  MineMenuView,
  EditInfoView,
  EditCardView,
  EditPayPasswordView
} from './components/index'
import GoBackView from '@/components/goback/index.vue'
export default {
  name: 'EditUsrInfoView',
  components: {
    MineHeaderView,
    MineMenuView,
    EditInfoView,
    EditCardView,
    EditPayPasswordView,
    GoBackView
  },
  data () {
    return {
      usrData: null
    }
  },
  mounted () {
    this.getUsr()
  },
  methods: {
    openMenu () {
      const that = this
      this.$nextTick(() => {
        that.$refs.mmv.showMenu = true
      })
    },
    async getUsr () {
      await this.$http({
        method: 'post',
        url: 'getusr'
      }).then(res => {
        this.usrData = res.data
        const that = this
        this.$nextTick(() => {
          that.$refs.editInfo.frm.nickname = that.usrData.nickname
          that.$refs.editInfo.frm.mobile = that.usrData.mobile
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped></style>
